import React, { Component, Fragment } from "react";

import Seo from './Seo'
import Footer from './Footer'


import Autocomplete from "react-autocomplete";
// import { getValue } from "../../utils/sessionManager";
import Button from "../../components/Button/Button";

import { getAuthToken } from "../../action/FundComparison";
import { getAmcInfo } from "../../action/FundComparison";

import { getSubAssetCategories } from "../../action/FundComparison";
//import './FundNew.scss'
import './FundDetails.scss'
// import { getAssestScheme } from '../../actions/transactionActions';



class FundHouse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      selectedScheme: "",
      fund_house: {},
      scheme_error: "",
      showFundDetailsPage: false,
      selectedFundSchemeCode: "",
      selectedFundScheme: "",
      AuthTokenRes: "",
      amc_name: "",
      Selected: "All",
      autoCompleteDataList: [],
      activeTab: "Equity",
      sub_assets: [],
      item:{}
    };
  }

  getFunds = async () => {
    const { AuthTokenRes, selectedFund } = this.state;
    let Values = {
      auth: AuthTokenRes,
      amc_name: selectedFund.slice(0, 6),
      amc_code: ""
    }
    try {
let test = []
      const schemeRes = await getAmcInfo(Values);
      const res = schemeRes.data;
      test.push(res.data)
      this.setState({ autoCompleteDataList: test[0] }, () => this.handleSelectedSchemetest());
    } catch (err) {
      console.error("getScheme, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  getToken = async () => {
    try {
      const tokenRes = await getAuthToken();
      const res = tokenRes.data;
      this.setState({ AuthTokenRes: res.data.auth }, () => this.getFunds());
    } catch (err) {
      console.error("handleToken, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  getFundCategoriesList = async () => {
    const { AuthTokenRes, activeTab, fund_house } = this.state;
    try {
      const res = await getSubAssetCategories(AuthTokenRes, fund_house.amc_code, activeTab);
      const subCategRes = res.data.data.asset_sub_categories;
      this.setState({ fund_category: subCategRes, });
    } catch (err) {
      console.error("getSubAssetCategories, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };


  componentDidMount() {
    const queryString = this.props.location.pathname.split("/");
    let selectedFund = queryString[2]
    this.setState({ selectedFund, showFundDetailsPage: true }, () => this.getToken())
  }
  

  handleSelectedSchemetest = () => {
    const { autoCompleteDataList } = this.state
    console.log(autoCompleteDataList)
    this.setState({
      selectedFundScheme: autoCompleteDataList[0].amc_name,
      fund_house: autoCompleteDataList[0],
    }, () => this.getFundCategoriesList());
  };

  handleSelectedScheme = (value, item) => {
    this.setState({
      selectedFundScheme: value,
      fund_house: item,
    }, () => this.getFundCategoriesList());
  };

  handleSearchScheme = (e) => {
    const value = e.target.value;
    this.setState({ selectedFund: value }, () => this.getFunds());
  };


  render() {
    const {
      showFundDetailsPage,
      selectedFundScheme,
      fund_house,
      Selected,
      autoCompleteDataList,
      selectedFund,
      scheme_error
    } = this.state;
    return (
      <Fragment>
        {showFundDetailsPage && (
          <Fragment>
            <div className="container-fluid pt_200 bg_fund">
              <div className="row justify-content-center">
                <div className="col-md-5">
                  <div className="form-group has-search al_auto_search">
                    <i className="fa fa-search form-control-search text-warning"></i>
                    <Autocomplete
                      inputProps={{
                        placeholder: "Search any Fund House",
                      }}
                      getItemValue={(item) => item.amc_name}
                      items={autoCompleteDataList}
                      renderItem={(item, isHighlighted) => (
                        <div
                          key={item.amc_name}
                          style={{
                            background: isHighlighted ? "lightgray" : "white",
                            cursor: "pointer",
                          }}
                        >
                          {item.amc_name}
                        </div>
                      )}
                      value={selectedFund}
                      onChange={(e) => this.handleSearchScheme(e)}
                      onSelect={(value, item) => this.handleSelectedScheme(value, item)}
                    />
                    <div className="input-error">{scheme_error}</div>
                  </div>
                </div>
              </div>
              <div className="par_6 text-center my-5">
                {selectedFundScheme}
              </div>
              <div className="row d-flex justify-content-between mb-3 mx-5">
                <div className="par_6  text-warning">
                  Total Fund Managers : {fund_house.total_fund_managers}

                </div>
                <div className="btn-group mb-2">
                  <Button
                    type="button"
                    size="md"
                    text="All"
                    customClass={`btn border-warning ${Selected === "All" ? "btn btn-warning" : ""}`}
                    onClick={() => this.setState({ Selected: "All" })}
                  />
                  <Button
                    type="button"
                    size="md"
                    text="Regular"
                    customClass={`btn border-warning  ${Selected === "Regular" ? "btn btn-warning" : ""}`}
                    onClick={() => this.setState({ Selected: "Regular" })}
                  />
                  <Button
                    type="button"
                    size="md"
                    text="Direct"
                    customClass={`btn border-warning  ${Selected === "Direct" ? "btn btn-warning" : ""}`}
                    onClick={() => this.setState({ Selected: "Direct" })}
                  />
                </div>
              </div>
              <div class="mb-3 ">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card al_card al_card_1 bg_8 mb-5">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="row pl-0">
                              <h5
                                className="card-title mb-0 par_6"
                              >
                                AUM Stats (In Crores)
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col">
                            <span className="data_1">
                              Total AUM
                            </span>
                            <p className="header_1">{fund_house.total_aum_amc}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">Equity</span>
                            <p className="header_1">{fund_house.total_aum_equity}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">Debt</span>
                            <p className="header_1">{fund_house.total_aum_fixed_income}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Hybrid
                            </span>
                            <p className="header_1">{fund_house.total_aum_hybrid}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Global
                            </span>
                            <p className="header_1">{fund_house.total_aum_global}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Commodity
                            </span>
                            <p className="header_1">{fund_house.total_aum_commodity}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3 ">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card al_card al_card_1 bg_8 mb-5">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="row pl-0">
                              <h5
                                className="card-title mb-0 par_6"
                              >
                                Scheme Summary
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col">
                            <span className="data_1">
                              Total Schemes
                            </span>
                            {Selected === "All" &&
                              <p className="header_1">{Number(fund_house.total_schemes_direct) + Number(fund_house.total_schemes_broker)}</p>
                            }
                            {Selected === "Regular" &&
                              <p className="header_1">{fund_house.total_schemes_broker}</p>
                            }
                            {Selected === "Direct" &&
                              <p className="header_1">{fund_house.total_schemes_direct}</p>
                            }
                          </div>
                          <div className="col">
                            <span className="data_1">Equity</span>
                            <p className="header_1">{fund_house.total_schemes_equity}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">Debt</span>
                            <p className="header_1">{fund_house.total_schemes_fixed_income}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Hybrid
                            </span>
                            <p className="header_1">{fund_house.total_schemes_hybrid}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Global
                            </span>
                            <p className="header_1">{fund_house.total_schemes_global}</p>
                          </div>
                          <div className="col">
                            <span className="data_1">
                              Commodity
                            </span>
                            <p className="header_1">{fund_house.total_schemes_commodity}</p>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer/>
            <Seo/>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default FundHouse;
